import {
  ModalBuilder,
  Table,
  notifySuccess,
  ActionMenu,
} from "@redriver/cinnamon";
import React from "react";
import { Button, DropdownItem, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { submitSheet } from "./actions";
import { useDispatch } from "react-redux";

const SubmitSheet = ({
  sheet,
  onSubmitted,
  generateDocument,
  boilerPlateTandCsId,
}) => {
  const { t } = useTranslation("agreements", { keyPrefix: "SheetActions" });
  const dispatch = useDispatch();
  const { sheetId, sheetName } = sheet;

  const translationPrefix = process.env.TRADE_AS_IPS
    ? "SubmitSheetIps"
    : "SubmitSheetPrincipal";

  const submitDisabled =
    sheet.missingCredit || (!boilerPlateTandCsId && process.env.TRADE_AS_IPS);

  return (
    <ModalBuilder
      submitAction={submitSheet}
      submitParams={{ sheetId: sheetId ?? sheet.id }}
      onSubmitted={() => {
        dispatch(notifySuccess("Sheet successfully submitted"));
        onSubmitted();
      }}
      renderTrigger={(onTrigger) =>
        generateDocument ? (
          <Button
            className="generate-btn"
            primary
            onClick={onTrigger}
            disabled={submitDisabled}
          >
            <Icon name="check" />
            {t(`${translationPrefix}.TriggerText`)}
          </Button>
        ) : (
          <DropdownItem onClick={onTrigger} disabled={submitDisabled}>
            {t(`${translationPrefix}.TriggerText`)}
          </DropdownItem>
        )
      }
      renderModal={(modalProps) => (
        <TranslatedModal.Confirmation
          {...modalProps}
          header={t(`${translationPrefix}.ModalHeader`)}
          content={t(`${translationPrefix}.ModalContent`, { sheetName })}
        />
      )}
    />
  );
};

export default SubmitSheet;
